





























import {
  Component,
  Vue,
  Inject,
  Prop,
  Model,
  Watch
} from 'vue-property-decorator'
import appconst from '@/lib/appconst'
@Component
export default class BatchEdit extends Vue {
  @Prop()
  @Model('change', { type: Boolean })
  modal!: boolean

  templateUrl = ''
  uploadUrl = ''
  mounted() {
    this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/batchEdit/templateFile`
    this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/batchEdit/excel/upload`
  }
  cancel() {
    this.$emit('change', false)
  }

  downloadTemplate() {
    location.href = this.templateUrl
  }
  uploadSuccess() {
    this.$Message.success('导入成功')
    this.$emit('change', false)
  }
}
